import { getFullUrl } from 'hubspot-url-utils';
import { useDetailsPageContext } from '../../context/DetailsPageContext';

// @ts-expect-error untyped dependency
import IFrame from 'ui-addon-iframeable/host/IFrame';
import { jsx as _jsx } from "react/jsx-runtime";
export function HubSpotOAuthStep({
  oauthQueryParams,
  portalId,
  onOAuthSuccess,
  codeChallenge,
  codeChallengeMethod
}) {
  const {
    trackInteraction
  } = useDetailsPageContext();
  const pkceParams = codeChallenge && codeChallengeMethod ? `&${new URLSearchParams({
    code_challenge: codeChallenge,
    code_challenge_method: codeChallengeMethod
  }).toString()}` : '';
  return /*#__PURE__*/_jsx(IFrame, {
    src: `${getFullUrl('app')}/oauth/${portalId}/embedded/authorize${oauthQueryParams}${pkceParams}`,
    embeddedPassthruProps: {
      allowParentRedirect: true
    },
    onReady: () => {},
    onClose: () => {},
    onMessage: ({
      payload
    }) => {
      if (payload.type === 'OAUTH_SUCCESS') {
        onOAuthSuccess(payload.redirectUri);
        trackInteraction({
          action: 'complete hubspot oauth'
        });
      }
    },
    width: "100%",
    height: "100%",
    use: "default"
  });
}